<template>
	<AppPage ref="inventarisation-page">
		<AppPageTitle full-width class="pb-0">
			<div>
				<h2>Klanten</h2>
			</div>
			<div class="ml-auto flex gap-2.5">
				<span v-if="showDevLabels">
					{{ loadingStore.unsavedChanges }}
				</span>
				<AppButton @click="foldAll(false)">Alles inklappen</AppButton>
				<AppButton @click="foldAll(true)">Alles uitklappen</AppButton>
			</div>
			<template #actions>
				<AppTabBar :tabs="tabs" class="bg-white" />
			</template>
		</AppPageTitle>
		<router-view v-slot="{ Component }">
			<keep-alive>
				<component :is="Component" />
			</keep-alive>
		</router-view>
	</AppPage>
</template>

<script lang="ts" setup>
import { useFeatureFlag } from "@/composables/useFeatureFlag";
import type { NavTab } from "@/models/NavTab";
import { useLoadingStore } from "@/store/useLoadingStore";
import { useUserStore } from "@/store/useUserStore";
import { useTemplateRef, computed } from "vue";

const livingSituationPage = useFeatureFlag("INVENTARISATION_LIVING_SITUATION");

const dataRequestEnabled = useFeatureFlag("data-request");
const userStore = useUserStore();
const loadingStore = useLoadingStore();

const showDevLabels = import.meta.env.VITE_SHOW_DEV_LABELS === "true";

const tabs = computed(() => {
	const tabs: NavTab[] = [];

	if (dataRequestEnabled.value && userStore.role !== "customer") {
		tabs.push({ name: "Gegevens ophalen", id: 0 });
	}

	tabs.push({ name: "NAW-gegevens", id: 1 });
	tabs.push({ name: "Inkomen", id: 2 });
	tabs.push({ name: "Verplichtingen", id: 3 });
	tabs.push({ name: "Vermogen", id: 5 });

	if (livingSituationPage.value) {
		tabs.push({ name: "Woonsituatie", id: 4 });
	}

	tabs.push({
		name: "HuidigeHypotheek",
		label: "Huidige hypotheek",
		id: 6,
	});

	return tabs;
});

const inventarisationPage = useTemplateRef("inventarisation-page");

function foldAll(open: boolean) {
	const formEl = inventarisationPage.value?.$el as HTMLDivElement;
	const details = formEl.querySelectorAll("details");
	details.forEach((element) => (element.open = open));

	const selector = open
		? ".app-card.is-collapsed.collapsible .app-card-top-section"
		: ".app-card.collapsible:not(.is-collapsed) .app-card-top-section";
	const appCards = formEl.querySelectorAll(selector);
	appCards.forEach((element) => (element as HTMLElement).click());
}
</script>

<style scoped>
.v-enter-active {
	transition: opacity 50ms ease-out;
}
.v-leave-active {
	transition: opacity 50ms ease-in;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
}
</style>
